import axios from "@/plugins/axios";

let url = "/api/console/shop/orders";

export default {
    gets(data){
        return axios.get(url, data).then(result => result.data);
    },
    get(data){
        return axios.get(`${url}/${data._id}`).then(result => result.data);
    },
    post(data){
        return axios.post(url, data).then(result => result.data);
    },
    put(data){
        return axios.put(`${url}/${data._id}`, data).then(result => result.data);
    },
    delete(data){
        return axios.delete(`${url}/${data._id}`).then(result => result.data);
    },
    refund(data){
        return axios.post(`${url}/${data._id}/refund`).then(result => result.data);
    },
    batch(data){
        return axios.post(`${url}/${data._id}/batch`).then(result => result.data);
    },
    testApiPost(data) {
        return axios.post(`${url}/test-api`, data).then(result => result.data);
    },


    issues: {
        gets(_order, data){
            return axios.get(`${url}/${_order}/issues`, data).then(result => result.data);
        },
        get(_order, data){
            return axios.get(`${url}/${_order}/issues/${data._id}`).then(result => result.data);
        },
        post(_order, data){
            return axios.post(`${url}/${_order}/issues`, data).then(result => result.data);
        },
        put(_order, data){
            return axios.put(`${url}/${_order}/issues/${data._id}`, data).then(result => result.data);
        },
        delete(_order, data){
            return axios.delete(`${url}/${_order}/issues/${data._id}`).then(result => result.data);
        },
        cancel(_order, _issue){
            return axios.post(`${url}/${_order}/issues/${_issue}/cancel`).then(result => result.data);            
        },
        refund(_order, _issue){
            return axios.post(`${url}/${_order}/issues/${_issue}/refund`).then(result => result.data);            
        }
    },

    zips: {
        gets(_order, data){
            console.log(_order);
            return axios.get(`${url}/${_order}/zips`).then(result => result.data);
        },
    }
}
